// src/padplanner/ProjectScope.jsx
//
// Which project a PadPlanner list is showing, when the TopNav picker names
// one. The server filters every count, list and pin by it, so a project with
// no plans reads as an empty organization unless the page says so: the bar
// names the project, how many of the organization's plans it leaves out
// (the dashboard's counts.outside_project: in another project or in none),
// and offers the picker's own "all projects".

/** outside: the plans left out, or null when not known. */
export default function ProjectScope({ projectName, outside = null, onShowAll }) {
  if (!projectName) return null;
  const more = outside === 1 ? "1 more plan in your organization is" : `${outside} more plans in your organization are`;
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border border-accent-action/40 bg-accent-action/10 px-3 py-1.5 text-[13px] text-fg-primary"
      data-testid="pp-project-scope">
      <span>Showing plans in project <span className="font-semibold">{projectName}</span>.</span>
      {outside > 0 && <span className="text-fg-secondary" data-testid="pp-outside-project">{more} outside it.</span>}
      <button type="button" className="op-btn op-btn--sm" data-testid="pp-show-all-projects" onClick={onShowAll}>Show all projects</button>
    </div>
  );
}
